<template>
    <div>
        <div v-if="cleanConditions && cleanConditions.length > 0">
            <div v-html="getValueFromCondition"></div>
        </div>
        <div :title="formattedValue" class="ellipsis-line-clamp-4" v-if="!cleanConditions || cleanConditions.length == 0">
            <span>{{formattedValue}}</span>
        </div>
    </div>
</template>
<script>
    import _ from "lodash";

    /**
     * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS BOTONES
     * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
     * */
    export default {
        name: "cell-dt-string-type-component",
        data() {
            return {
            }
        },
        props: ['value', 'conditionsDict', 'index', 'readTransform'],        
        computed: {
            formattedValue() {
                if (this.value && !Number.isNaN(this.value) && this.value !== '' && this.readTransform) {
                    return eval(this.readTransform.replace('this', this.value))
                }
                return this.value;
            },
            cleanConditions(){
                return  this.conditionsDict.filter(x => x.Value != '')
            },
            getValueFromCondition() {
                var found = false;
                var index = 0;
                // Eval expression
                while (!found && index < this.cleanConditions.length) {

                    found = this.$parent.fnEvalCondition(this.cleanConditions[index].ValueCondition, this.formattedValue, this.index);
                    if (!found) index++;
                }
                // Get value if meet condition
                if (found) {
                    var expression = this.cleanConditions[index].Value.replace('{{value}}', this.formattedValue);
                    return expression;
                }
            },
        },        
        methods: {          
        }
    }

</script>
<style scoped>
    .ellipsis-line-clamp-4 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }
</style>
